import { Component, useEffect } from 'react';

import store from '../../redux/store';
import { actions } from '../../redux/actions';
import { assessorMenus } from '../../shared/utils/constants';
import Header from './Header';
import Sidebar from './Sidebar';
import AppRouter from '../../routers/AppRouter';

import './AppLayout.scss';

const RouteChangeDetector = (props) => {

    useEffect(() => {
        if ( props.location ) {
            const menu = assessorMenus.find(element => props.location.pathname.startsWith(element.redirectTo));
            if (typeof menu !== 'undefined') {
                store.dispatch(actions.setScreenName(menu.name));
            }
        }
    }, [props?.location?.pathname]);

    return null;
};

export default class Applayout extends Component {
    constructor(props){
        super(props);
    }

    render(){
        return(
            <div className='d-flex flex-grow-1 overflow-hidden'>
                <RouteChangeDetector {...this.props} />
                <Sidebar {...this.props} />
                <div className='app-content-column d-flex flex-column flex-grow-1'>
                    {!this.props.location?.pathname?.match(/^\/(home|clients|sites|projects|plans|settings|profile)(\/|$)/) && (
                        <Header {...this.props} />
                    )}
                    {this.props.location?.pathname?.match(/^\/(home|clients|sites|projects|plans|settings|profile)(\/|$)/) && (
                        <div className="d-lg-none mobile-hamburger-bar">
                            <button 
                                className="border-0 bg-transparent d-flex align-items-center justify-content-center" 
                                onClick={() => store.dispatch(actions.setSideBar(true))}
                                aria-label="Open navigation menu"
                            >
                                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <line x1="3" y1="12" x2="21" y2="12"></line>
                                    <line x1="3" y1="6" x2="21" y2="6"></line>
                                    <line x1="3" y1="18" x2="21" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                    )}
                    <main className='content-box'>
                          
                        <AppRouter {...this.props} />
                    </main>
                </div>
            </div>
        );
    }
}